import { FaPercent } from "react-icons/fa6"
import { TableCircleButton } from "./TableCircleButton"

export const PercentilesButton = ({ onClick }: { onClick?: () => void }) => {
  return (
    <TableCircleButton onClick={onClick}>
      <FaPercent />
    </TableCircleButton>
  )
}